import React from "react";
import {ShowMore} from "./../../../shared/organisms/showMore";

import "./FrequentlyAskedQuestionsContent.scss";

export class FrequentlyAskedQuestionsContent extends React.Component<{}, {}>{

  private cleanText(text: string): string {
    return text.replace(/\s+/g, " ");
  }

  public render() {

    return (

      <div className="faq">
        <div className="heading-with-intro">
          <div className="heading-with-intro-description">Frequently Asked Questions</div>
        </div>

        <section className="faq-content">

          <div className="faq-item">
            <p className="faq-title">Is my money safe with TravelLocal?</p>
            <ShowMore
              className="clearfix"
              text={this.cleanText(`
                Yes, your money is 100% protected. In fact, we are the safest way you could book a holiday with a local travel company, anywhere in the world.
                That’s because we are ABTA members - the Association of British Travel Agents - and we hold an ATOL licence - the Air Travel Organiser's Licence.
                These UK-based industry bodies are known and respected worldwide and, between them, offer 100% protection of all customers' money – regardless
                of where you live or where you're travelling to. You pay TravelLocal, a UK company, online by credit or debit card and we pay the local travel
                company. This means there’s no need for you to transfer money to a company in a far-flung country. In addition we also insure all bookings made
                via our website with a UK insurance company, so you are also protected in the unlikely event of the bankruptcy of the local travel company,
                as well as TravelLocal itself. We undertake an extensive due diligence process on all the local travel companies we work with, to check that
                they can serve you well. For more information, or for any questions you have don't hesitate to contacts us. Further details are also available
                in our terms and conditions.
              `)}
              maxLength={120}
              expanderLink={true}
             />
          </div>

          {/* Removed during COVID whilst we no longer offer flights, to be re-added once that's all over */}
          {/* <div className="faq-item">
            <p className="faq-title">What about flights?</p>
            <ShowMore
              className="clearfix"
              text={this.cleanText(`
                We are perfectly placed to book any flights that you need to make your holiday happen. We provide flights from anywhere, to anywhere, and by booking them with your trip you benefit from complete ATOL protection. For any advice, simply contact our Flights Team on flights@travellocal.com and they will be in touch.
              `)}
              maxLength={120}
              expanderLink={true}
             />
          </div> */}

          <div className="faq-item">
            <p className="faq-title">How do you find the right local travel company?</p>
            <ShowMore
              className="clearfix"
              text={this.cleanText(`
                The most important thing we start with is to understand how satisfied their current and previous international customers have been with the
                holidays they have created for them. We’re looking for local travel experts who have a proven track record. We also have extensive experience
                of working in the travel industry. Over time we have got to know which companies are the best - the most timely, the most original, the ones
                who can really deliver. But of course we still test every single one of them. We do a mystery shopper exercise to test responsiveness.
                If they pass that, we interview each of them individually, talking to owners and staff about how they do what they do. Finally we undertake
                a detailed written due diligence exercise where we check key company documentation. If you’d like more detail on how we choose our local
                companies don't hesitate to get in touch with us.
              `)}
              maxLength={120}
              expanderLink={true}
             />
          </div>

          <div className="faq-item">
            <p className="faq-title">Is TravelLocal a Fairtrade company? </p>
            <ShowMore
              className="clearfix"
              text={this.cleanText(`
                We help you to cut out the middleman and to book your holiday with carefully selected local travel companies in your destination – so you get
                a better holiday and they get a fairer deal. Fairtrade doesn't exist for the travel industry (yet!). If it did we believe that we would qualify
                straight away. Fairness in the travel industry is mostly about where the money which you pay for your holiday goes. If you were to book with
                big international travel companies or even with a travel agency in the country where you live, you would probably be surprised (or indeed
                shocked) by how little of your money actually reaches your destination. For travel to be fairer more of your money needs to go straight to
                the destination itself - that's where the expertise really lies. More money into local economies means more employment and better skills over
                time. For more information on how and why we set up TravelLocal, see our About us page, a summary of ‘Our values’ and a summary of
                ‘How to TravelLocal’.
              `)}
              maxLength={120}
              expanderLink={true}
             />
          </div>

        </section>
        </div>
        );
  }
}
